import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

const getConfiguration = async (configName) => {
  const response = await axiosPrivate.get(`/configurations/${configName}`);
  if (response.data.error) helpers.throwError(response.data.error);
  return response.data;
};

const getGenericConfiguration = async (configName) => {
  const response = await axiosPrivate.get(`/configurations?key=${configName}`);
  if (response.data.error) helpers.throwError(response.data.error);
  return response.data;
};

export default { getConfiguration, getGenericConfiguration };
